const common = {
  "nav.home": "Fillimi",
  "nav.services": "Shërbimet",
  "nav.about": "Rreth Nesh",
  "nav.pricing": "Çmimet",
  "nav.testimonials": "Dëshmitë",
  "nav.contact": "Kontakti",
  "nav.booking": "Termini",
  "nav.gallery": "Galeria",
  "nav.team": "Ekipi",

  "hero.title_line1": "Bukuria Juaj.",
  "hero.title_line2": "Arti Ynë.",
  "hero.subtitle": "Mjekësi dentare premium në atmosferë luksoze. Ekspertë të vlerësuar ndërkombëtarisht për buzëqeshjen tuaj të re — deri në 70% më të lira se në DE/AT/CH.",
  "hero.cta": "Rezervoni Terminin",
  "hero.badge": "KLINIKË PREMIUM TIRANË · DERI NË 70% MË E LIRA SE NË DE/AT/CH",
  "hero.stat1.value": "7.500+",
  "hero.stat1.label": "Pacientë",
  "hero.stat2.value": "15",
  "hero.stat2.label": "Vjet Përvojë",
  "hero.stat3.value": "98%",
  "hero.stat3.label": "Kënaqësi",

  "services.tag": "SHËRBIMET TONA",
  "services.heading": "Ekselencë në çdo trajtim",
  "services.dental.title": "Mjekësia Dentare",
  "services.dental.desc": "Implante dentare, fasa, kurora zirkoni, zbardhje dhe më shumë. Proteza premium me diagnostikë 3D më të fundit — deri në 70% më të lira se në Gjermani.",
  "services.dental.count": "12 Trajtimet",
  "services.surgery.title": "Kirurgjia Plastike",
  "services.surgery.desc": "Lifting, rinoplastik, zmadhim i gjirit, liposuksion dhe më shumë. Standarde më të larta sigurie me hotel dhe transfer të përfshirë.",
  "services.surgery.count": "21 Ndërhyrje",
  "services.hair.title": "Transplantimi i Flokëve",
  "services.hair.desc": "Transplantimi FUE i flokëve me teknikën më të fundit mikro-punçuese. Deri në 5,000 fasha — absolutisht pa shenja, rezultat natyral i dendur. Analiza falas e flokëve e përfshirë.",
  "services.hair.count": "1 Trajtim",
  "services.cta": "Zbuloni të Gjitha Shërbimet",

  "about.tag": "VENDI YNË",
  "about.heading_line1": "Bukuria e lindur",
  "about.heading_line2": "në Shqipëri.",
  "about.description": "Në zemër të Tiranës, kryeqyteti pulzues i Shqipërisë, lindi Esteva Clinic nga një vizion: të bashkonte estetikën e klasit botëror me ngrohtësinë e mikpritjes mesdhetare. Shqipëria — një vend i bukurisë mahnitëse, nga ujërat turkuaz të Adriatikut deri te majat madhështore të Alpeve Shqiptare — po përjeton një Rilindje spektakolare. Ndërsa vendi rritet me shpejtësi dhe zhvillohet në një nga destinacionet më të kërkuara të Europës, ne krijuam një vend në Tiranë ku ekselenca ndërkombëtare mjekësore takohet me ndjenjën autentike të qenit vërtet i mirëpritur. Klinika jonë pasqyron shpirtin e Shqipërisë: e re, ambicioze, plot zemër — dhe gati të pushtojë botën.",
  "about.quote": "Shqipëria më mësoi se bukuria e vërtetë lind nga autenticiteti. Këtu, midis maleve dhe detit, ne rritemi së bashku — vendi, ekipi ynë dhe çdo person që vjen te ne.",
  "about.name": "Dr. Nertila Basha",
  "about.position": "CEO, Dentiste, Implantologe & Protetiste",

  "pricing.tag": "PAKETAT E ÇMIMEVE",
  "pricing.heading_line1": "Ekselencë",
  "pricing.heading_line2": "Transparente.",
  "pricing.subtitle": "Çdo paketë e përshtatur sipas nevojave tuaja. Pa kosto të fshehura, pa kompromise.",
  "pricing.basic.title": "Essential",
  "pricing.basic.price": "nga 1.490 €",
  "pricing.basic.feature1": "Konsultimi dhe Analiza e Parë",
  "pricing.basic.feature2": "1 Trajtim sipas Zgjedhjes",
  "pricing.basic.feature3": "Paketa Bazike e Kujdesit",
  "pricing.premium.title": "Premium",
  "pricing.premium.price": "nga 3.990 €",
  "pricing.premium.feature1": "Konsultimi VIP i Parë",
  "pricing.premium.feature2": "2 Trajtimet e Kombinuara",
  "pricing.premium.feature3": "Kujdesi Premium dhe Produkte",
  "pricing.luxe.title": "Luxe",
  "pricing.luxe.price": "nga 7.490 €",
  "pricing.luxe.feature1": "Asistenti Personal i Bukurisë",
  "pricing.luxe.feature2": "3 Trajtimet + Paketa e Hotelit",
  "pricing.luxe.feature3": "1 Vit Kujdes dhe Garanci",
  "pricing.exclusive.title": "Exclusif",
  "pricing.exclusive.price": "Individuale",
  "pricing.exclusive.feature1": "Transformim i Plotë",
  "pricing.exclusive.feature2": "Të Gjitha Trajtimet e Përfshira",
  "pricing.exclusive.feature3": "Kujdes gjatë gjithë Jetës",
  "pricing.dental_title": "LISTA E ÇMIMEVE DENTARE",
  "pricing.surgery_title": "LISTA E ÇMIMEVE TË KIRURGISË PLASTIKE",
  "pricing.hair_title": "LISTA E ÇMIMEVE TË TRANSPLANTIMIT TË FLOKËVE",
  "pricing.included_title": "Shërbimet e Përfshira",
  "pricing.included_over_3000": "Për vlerësim mbi 3.000 €: hoteli, taksia, bileta e fluturimit dhe skanimi 3D i gojës janë të përfshira.",
  "pricing.included_over_1500": "Për vlerësim mbi 1.500 €: hoteli, taksia dhe skanimi 3D i gojës janë të përfshira.",
  "pricing.table_service": "SHËRBIMI",
  "pricing.table_price": "ÇMIMI (EUR)",
  "pricing.table_stay": "QËNDRIMI NË SPITAL DHE HOTEL",
  "pricing.table_total": "TOTALI",
  "pricing.note_individual": "Çmimet individuale mund të ndryshojnë sipas kompleksitetit të ndërhyrjes. Një vlerësim i detajuar do të jepet gjatë konsultimit tuaj.",
  "pricing.cta": "Konsultim Falas",
  "instagram.tag": "NA NDIQNI",
  "instagram.heading": "Një Vështrim në Ekselencë.",
  "instagram.subtitle": "Na ndiqni në Instagram për përvoja ekskluzive, momente para-pas dhe trendet më të fundit në mjekësinë estetike.",
  "instagram.cta": "Ndiqni @estevaclinic",

  "testimonials.tag": "DËSHMITË E KLIENTËVE",
  "testimonials.heading": "Çfarë Thonë Klientët Tanë",
  "testimonial1.text": "U fluturova nga Mynihu drejt Tiranës — dhe ishte vendimi më i mirë i jetës sime. 8 muaj më parë bëra rinoplastikun dhe rezultati është thjesht jashtëzakonisht natyral. Dr. Krasniqi nuk më premtoi asgjë gjatë konsultimit që nuk mund të mbante. Kjo më bindi. Klinika është super moderne, ekipi flet shqip dhe kujdesi pas operacionit ishte fenomenal. Nuk e kam pendoar asnjëherë.",
  "testimonial1.name": "Markus W.",
  "testimonial1.role": "Rinoplastik, Mynih",
  "testimonial2.text": "Dëshiroja fasa prej vitesh, por çmimet në Zvicër ishin absurde. Një mik më rekomandoi Esteva Clinic dhe mendova: pse jo? Diferenca është — dhe nuk e ekzagjeroj — sikur dikur më ndërtoi një gojë të re. 12 fasa, perfekt simetrike, pa asnjë shenjë artificiale. Dentistja ime në shtëpi mbeti pa fjalë. Dhe Tirana është një qytet jashtëzakonisht i bukur.",
  "testimonial2.name": "Sophie L.",
  "testimonial2.role": "Kozmetikë Dentare, Cyrih",
  "testimonial3.text": "Kisha frikë nga liftingu — të gjitha ato histori horror me fytyra maskë. Por Dr. Krasniqi më shpjegoi me qetësi dhe më tregoi teknikën SMAS. Rezultati? Konturet e fytyrës janë të ngushta, por unë dukem si vetja — vetëm 10 vjet më e re. Askush nuk e vëren që kam bërë diçka — por të gjithë thonë: 'Dukesh kaq e freskët!' Pikërisht ajo që dëshiroja. Natyral, pa fytyrë maskë.",
  "testimonial3.name": "Chiara R.",
  "testimonial3.role": "Lifting, Milano",
  "testimonial4.text": "Kam luftuar me dhëmbët për 15 vjet. Kurora, ura, provizore — të gjitha mjerane. Në moshën 43 vjeç arrita në pikën ku thashë: tani e bëj si duhet. 8 implante dentare, 2 seanca, pak dhimbje. Sot, 10 muaj më vonë, ha dhe qesh për herë të parë prej vitesh pa menduar. Momenti kur vajza ime tha: 'Baba, po qesh ndryshe' — çdo centi ia vlejti.",
  "testimonial4.name": "Alexander K.",
  "testimonial4.role": "Implante Dentare, Hamburg",
  "testimonial5.text": "Erdha për zmadhimin e gjirit, mbetva për përvojën e plotë. Së pari operacioni, pastaj ekipi më bindi të bëja edhe kurora zirkoni. Ata kanë këtë shikim për tërësinë — e kuptojnë se si gjithçka funksionon së bashku. Nuk ndihesh si paciente, por si mik. Që nga minuta e parë. Dhe kafeja në Tiranë është e pakrahasueshme.",
  "testimonial5.name": "Isabella M.",
  "testimonial5.role": "Transformim i Plotë, Vjenë",
  "testimonial6.text": "Raporti çmim-cilësi është i shkëlqyer, pa dyshim. Kurorat e mia të reja në zirkon duken shkëlqyeshëm dhe ekipi ishte vërtet i sjellshëm. E vetmja pikë negative: komunikimi para mbërritjes mund të ishte pak më i qartë — m'u desh të pyesja dy herë për dokumentat. Por në vend gjithçka shkoi pa probleme. 4 kurora, 2 ditë, rezultat i shkëlqyer. Do të kthehesha përsëri.",
  "testimonial6.name": "Thomas G.",
  "testimonial6.role": "Kurora Zirkoni, Berlin",
  "testimonial7.text": "Shkova në mars për transplant flokësh FUE (3.200 fasha). Vetë operacioni ishte profesional, ekipi u kujdes mirë për mua. Tani pas 5 muajsh, rritja është e dukshme por rezultati final sigurisht që ende pret. Mezi pres muajin e 12-të. Klinika është moderne, Tirana është një qytet i mrekullueshëm. Fluturimi dhe hoteli ishin të përfshira — gjithçka shkoi mirë.",
  "testimonial7.name": "David R.",
  "testimonial7.role": "Transplant Flokësh, Frankfurt",
  "testimonial8.text": "Shkova për një rinoplastikë të vogël — ndërhyrja shkoi mirë dhe jam e kënaqur me rezultatin. Megjithatë, ditët e para pas operacionit ishin më të vështira se sa prisja, do të kisha dashur të isha përgatitur më mirë. Por kujdesi pas operacionit ishte i shkëlqyer, ekipi u përpoq shumë. Pas 6 muajsh, gjithçka është shëruar perfekt.",
  "testimonial8.name": "Laura B.",
  "testimonial8.role": "Rinoplastikë, Shtutgart",

  "booking.tag": "REZERVIMI",
  "booking.heading_line1": "Udhëtimi juaj fillon",
  "booking.heading_line2": "me një bisedë.",
  "booking.description": "Rezervoni tani konsultimin tuaj personal. Ekspertët tanë marrin kohë për dëshirat tuaja individuale dhe krijojnë një koncept trajtimi të personalizuar — me diskrecion dhe besueshmëri.",
  "booking.cta": "Rezervoni Terminin",
  "booking.hero_subtitle": "Zgjidhni datën dhe orën tuaj të preferuar. Ekipi ynë do t'ju kthehet brenda 24 orëve me një konfirmim.",
  "booking.select_date_hint": "Ju lutemi zgjidhni së pari një datë për të parë orët në dispozicion.",
  "booking.your_data": "Të Dhënat Tuaja",
  "booking.form_subtitle": "Plotësoni formularin për të finalizuar termin tuaj.",
  "booking.firstname": "Emri *",
  "booking.firstname_placeholder": "Emri",
  "booking.lastname": "Mbiemri *",
  "booking.lastname_placeholder": "Mbiemri",
  "booking.email": "Email *",
  "booking.email_placeholder": "email@juaj.al",
  "booking.phone": "Telefoni *",
  "booking.phone_placeholder": "+41 76 559 39 93",
  "booking.service_label": "Trajtimi i Dëshiruar *",
  "booking.service_placeholder": "Ju lutemi zgjidhni",
  "booking.service_combined": "Trajtim i Kombinuar",
  "booking.service_consultation": "Konsultim",
  "booking.package_label": "Paketa e Dëshiruar",
  "booking.package_undecided": "Ende i pavendosur",
  "booking.package_essential": "Essential – nga 1.490 €",
  "booking.package_premium": "Premium – nga 3.990 €",
  "booking.package_luxe": "Luxe – nga 7.490 €",
  "booking.package_exclusif": "Exclusif – Individuale",
  "booking.message_label": "Dëshira të Veçanta ose Shënime",
  "booking.message_placeholder": "Na tregoni çfarë duhet të kemi kujdes të veçantë...",
  "booking.max_chars": "Maks. 500 karaktere",
  "booking.privacy_consent": "Jam dakord që të dhënat e mia të ruhen dhe përpunohen për rezervimin e terminit. Kam lexuar politikën e privatësisë.",
  "booking.select_datetime_warning": "Ju lutemi zgjidhni datën dhe orën për të përfunduar rezervimin.",
  "booking.success_title": "Faleminderit për rezervimin tuaj!",
  "booking.success_message": "Do t'ju kontaktojmë brenda 24 orëve.",
  "booking.time_label": "Zgjidhni Orën",
  "booking.time_selected": "Zgjedhur:",
  "booking.time_unit": "Ora",

  "footer.tagline": "Esteva Clinic — Ku bukuria bëhet art.",
  "footer.services": "Shërbimet",
  "footer.about": "Rreth Nesh",
  "footer.legal": "Ligjore",
  "footer.contact": "Kontakti",
  "footer.hair": "Mjekësia Dentare",
  "footer.dental": "Mjekësia Dentare",
  "footer.surgery": "Kirurgjia Plastike",
  "footer.botox": "Kirurgjia Plastike",
  "footer.team": "Ekipi Ynë",
  "footer.philosophy": "Filozofia",
  "footer.career": "Karriera",
  "footer.press": "Shtypi",
  "footer.imprint": "Informacioni Ligjor",
  "footer.privacy": "Politika e Privatësisë",
  "footer.terms": "Kushtet e Përdorimit",
  "footer.faq": "Pyetje të Shpeshta",
  "footer.newsletter_title": "Mbani Inspirimin.",
  "footer.newsletter_subtitle": "Përvoja ekskluzive, trajtime të reja dhe oferta speciale drejtpërdrejt në postën tuaj elektronike.",
  "footer.newsletter_placeholder": "Adresa juaj e emailit",
  "footer.newsletter_button": "Abonohuni",
  "footer.copyright": "© 2026 Esteva Clinic. Të Gjitha të Drejtat e Rezervuara.",
  "footer.seo_text": "Esteva Clinic është klinika juaj premium e bukurisë dhe dentare në Tiranë, Shqipëri. Ne ofrojmë implante dentare, kurora zirkoni, faseta, transplant flokësh (FUE), zmadhim gjoksi, rinoplastikë, lifting, Botox, liposuksion dhe kirurgji plastike deri në 70% më lirë se në Zvicër, Gjermani dhe Austri. Pacientët nga Cyrihu, Bazeli, Berna, Vjena, Mynihu dhe Berlini i besojnë Esteva Clinic. Konsultë e parë falas — rezervoni terminin tuaj tani.",

  "language.de": "DE",
  "language.it": "IT",
  "language.fr": "FR",
  "language.en": "EN",
  "language.sq": "SQ",

  "gallery.tag": "PARA & PAS",
  "gallery.heading_line1": "Rezultate që",
  "gallery.heading_line2": "flasin vetë.",
  "gallery.subtitle": "Transformime të vërteta të klientëve tanë. Çdo imazh tregon një histori besimi të rinovuar dhe bukurie natyrale.",
  "gallery.filter_all": "Të Gjitha",
  "gallery.filter_hair": "Mjekësia Dentare",
  "gallery.filter_dental": "Mjekësia Dentare",
  "gallery.filter_surgery": "Kirurgjia Plastike",
  "gallery.before": "Para",
  "gallery.after": "Pas",
  "gallery.view_details": "Shikoni Detajet",
  "gallery.close": "Mbyllni",
  "gallery.no_results": "Nuk u gjetën rezultate në këtë kategori.",
  "gallery.results_count": "{{count}} Rezultate",
  "gallery.patient": "Pacienti",
  "gallery.treatment": "Trajtimi",
  "gallery.result_after": "Rezultati pas",
  "gallery.months": "muajve",
  "gallery.disclaimer": "Rezultatet e treguara janë shembullore. Rezultatet individuale mund të ndryshojnë.",

  "service_detail.how_it_works": "PROCESI",
  "service_detail.benefits": "PËRFITIMET TUAJA",
  "service_detail.faq": "PYETJE TË SHPESHTA",
  "service_detail.process_title": "Procesi",
  "service_detail.benefits_title": "Përfitimet Tuaja",
  "service_detail.faq_title": "Pyetje të Shpeshta",
  "service_detail.cta_heading": "Gati për Transformimin Tuaj?",
  "service_detail.cta_subtitle": "Rezervoni tani konsultimin tuaj personal, pa detyrim. Ne marrim kohë për ju.",
  "pricing.back_to_pricing": "Kthehu te Lista e Çmimeve",
  "pricing.view_details": "Detajet",

  "team.tag": "EKIPI YNË",
  "team.heading_line1": "Ekselenca ka nevojë",
  "team.heading_line2": "për fytyra.",
  "team.subtitle": "Njihuni me ekspertët që bëjnë Esteva Clinic destinacionin kryesor për trajtime estetike premium në Europë. Çdo anëtar i ekipit është mjeshtër i fushës së vet.",
  "team.show_more": "Mëso më shumë",
  "team.show_less": "Shfaq më pak",
  "team.cta_heading": "Gati për transformimin tuaj?",
  "team.cta_subtitle": "Ekipi ynë pret me padurim t'ju njohë dhe t'ju udhëheqë në rrugën tuaj personale drejt bukurisë së re.",
  "team.cta_button": "Rezervoni konsultimin tani",
  "clinic.tag": "KLINIKA JONË",
  "clinic.heading_line1": "Hapësira të dizajnuara",
  "clinic.heading_line2": "për mirëqenien tuaj.",
  "clinic.subtitle": "Klinikë moderne dhe pajisje më të fundit në Tiranë. Nga rehati e sallës së pritjes deri te higjiena e laboratorit dentar — çdo detaj për mirëqenien tuaj.",
  "clinic.label_dental": "Laboratori Dentar",
  "clinic.label_consultation": "Dhoma e Konsultimit",
  "clinic.label_waiting": "Salla e Pritjes",
  "clinic.label_reception": "Rezepsioni",
  "clinic.dental_lab": "Laborator dentar modern me pajisje më të fundit",
  "clinic.consultation": "Dhomë e rehatshme konsultimi për biseda personale",
  "clinic.waiting": "Sallë e gjerë dhe mikpritëse pritjeje",
  "clinic.reception": "Rezepsion modern me dizajn elegant",

  "process.tag": "RUGA JUAJ DREJT NESH",
  "process.heading": "Udhëtimi juaj mjekësor, pa stres",
  "process.subtitle": "Ne ju udhëheqim në çdo fazë, duke garantuar një përvojë të sigurt, komfortable dhe të suksesshme në Esteva Clinic.",
  "process.step1.title": "Konsultimi",
  "process.step1.desc": "Ne kuptojmë nevojat tuaja mjekësore, historinë tuaj klinike dhe pritjet tuaja përmes një konsultimi online të parë me specialistët tanë.",
  "process.step2.title": "Planifikimi i Personalizuar",
  "process.step2.desc": "Ne krijojmë një plan trajtimi të personalizuar që përfshin të gjitha detajet e procedurës, kohën, koston dhe organizimin e plotë të udhëtimit.",
  "process.step3.title": "Kontrolli Mjekësor dhe Përgatitja",
  "process.step3.desc": "Ekipi ynë analizon dokumentacionin tuaj mjekësor dhe përgatit çdo detaj më parë — përfshirë dokumentet, udhëtimin dhe akomodimin.",
  "process.step4.title": "Trajtimi dhe Kujdesi",
  "process.step4.desc": "Ju merrni një trajtim të lartë cilësie në Esteva Clinic me vëmendje maksimale dhe një përvojë komfortable.",
  "process.step5.title": "Ndjekja dhe Mbështetja",
  "process.step5.desc": "Ne mbetemi pranë jush edhe pas trajtimit, duke ofruar mbështetje të vazhdueshme dhe udhëzime për një rikuperim optimal.",
  "trust.heading_line1": "Ne e transformojmë",
  "trust.heading_line2": "kujdesin në një përvojë besimi.",
  "trust.subtitle": "Besoni ekipit të Esteva Clinic për kujdes mjekësor të lartë cilësie, trajtime të personalizuara dhe mbështetje të plotë gjatë gjithë procesit tuaj të shërimit.",
  "trust.check1": "Konsultim mjekësor i specializuar",
  "trust.check2": "Kontrolle dhe diagnostikë të avancuara",
  "trust.check3": "Kirurgji e përgjithshme dhe e specializuar",
  "trust.check4": "Trajtime të personalizuara për pacientë ndërkombëtarë",
  "trust.check5": "Mbështetje e dedikuar për turizmin mjekësor",
  "trust.check6": "Mbështetje para, gjatë dhe pas trajtimit",

  "dental.tag": "EKSPERTIZA DENTARE",
  "dental.heading": "Buzëqeshja juaj e re fillon këtu",
  "dental.subtitle": "Zgjidhje moderne për buzëqeshjen tuaj: implante dentare, All-on-4 / All-on-6 / All-on-8, dizajni i buzëqeshjes, me materiale të larta cilësie dhe rezultate natyrale.",
  "dental.implant.title": "Implante Dentare Premium",
  "dental.implant.desc": "Implante titan, të qëndrueshme dhe natyrale, për të rivendosur funksionin dhe estetikën e buzëqeshjes tuaj afatgjatë.",
  "dental.crown.title": "Kurora Zirkoni",
  "dental.crown.desc": "Kurora estetike dhe të qëndrueshme zirkoni, të dizajnuara për një rezultat natyral dhe të qëndrueshëm.",
  "dental.veneer.title": "Fasa Dentare",
  "dental.veneer.desc": "Fasa të holla, estetike natyrale, ideale për korrigjimin e formës, ngjyrës dhe rreshtimit të dhëmbëve.",
  "dental.allon4.title": "All-on-4",
  "dental.allon4.desc": "Zgjidhje inovative me 4 implante dentare për çdo hapak, që mundësojnë dhëmbë të fiksuar, të qëndrueshëm dhe natyralë.",
  "dental.allon6.title": "All-on-6",
  "dental.allon6.desc": "Teknikë e avancuar me 6 implante dentare për çdo hapak, që garanton stabilitet maksimal dhe funksionalitet.",
  "dental.allon8.title": "All-on-8",
  "dental.allon8.desc": "Zgjidhje e plotë me 8 implante dentare për çdo hapak, ideale për mbajtje maksimale dhe 100% funksionalitet.",
  "dental.pterygoid.title": "Implante Pterigoide",
  "dental.pterygoid.desc": "Teknikë e avancuar që përdor implante pterigoide për të shmangur ndërtimin e kockës, duke mundësuar dhëmbë të fiksuar edhe në raste komplekse me pak kockë.",
  "dental.zygomatic.title": "Implante Zigomatike",
  "dental.zygomatic.desc": "Zgjidhje e avancuar me implante zigomatike për pacientë me humbje të rëndë kockore, shmang ndërtimin e kockës dhe garanton stabilitet të menjëhershëm dhe rezultate afatgjata.",
  "dental.maxillofacial.title": "Kirurgji Maksilofaciale",
  "dental.maxillofacial.desc": "Procedura të specializuara për trajtimin e problemeve komplekse të gojës, nofullës dhe fytyrës, me teknikë moderne dhe siguri maksimale.",
  "dental.cta": "Mëso më shumë",
  "overview.tag": "SPECIALITETET TONA",
  "overview.heading": "Tri Disiplina. Një Standard.",
  "overview.subtitle": "Stomatologji, kirurgji plastike dhe transplant flokësh — çdo specialitet me specialistë me përvojë ndërkombëtare, teknologji të fundit dhe një qëllim: bukuria juaj natyrore.",
  "overview.dental.title": "Stomatologji",
  "overview.dental.desc": "Nga implantet e vetme deri te rehabilitimi i plotë oral. Diagnostikë 3D e fundit, materiale me cilësi të lartë dhe një ekip implantologësh me përvojë për buzëqeshjen tuaj të re.",
  "overview.dental.treatments": "Implantet, Kurora Zirkoni, Fasetat, All-on-4/6/8, Zbardhimi, Ortodoncia, Shtimi i Kockës, Sinus Lift, Implantet Pterygoide dhe Zigomatike",
  "overview.surgery.title": "Kirurgji Plastike",
  "overview.surgery.desc": "Ndërhyrje estetike në nivelin më të lartë. Nga rinoplastika dhe lifting-u i fytyrës deri te konturimi i trupit — koncepte individuale me siguri maksimale dhe rezultate natyrale.",
  "overview.surgery.treatments": "Rinoplastikë, Lifting Fytyre, Shtim dhe Reduktim Gjoksi, Blefaroplastikë, Liposuksion, Abdominoplastikë, Lifting Krahësh dhe Këmbësh, Balon Gastrik",
  "overview.hair.title": "Transplant Flokësh",
  "overview.hair.desc": "Teknika FUE me mikropunkturë më e avancuar për një rezultat natyralisht të dendur dhe pa shenja. Deri në 5.000 grefta në një seancë — me analizë flokësh falas dhe plan trajtimi të personalizuar.",
  "overview.hair.treatments": "Transplant Flokësh FUE (deri në 5.000 grefta), Analizë Flokësh Falas, Plan Trajtimi i Personalizuar, Rezultat Natyral i Përhershëm",
  "overview.cta": "Të Gjitha Trajtimet dhe Çmimet",
  "implants.hero_title": "Implante Dentare Premium në Shqipëri",
  "implants.hero_subtitle": "Rigjeni gëzimin e buzëqeshjes, ngrënies dhe të folurit me besim falë implanteve dentare premium të Esteva Clinic.",
  "implants.hero_desc": "Ne ofrojmë zgjidhje moderne, të sigurta dhe të personalizuara për implante për pacientë që kërkojnë cilësi, estetikë dhe stabilitet afatgjatë.",
  "implants.why_title": "Pse të zgjidhni implante dentare tona?",
  "implants.why_intro": "Implantet dentare janë një zgjidhje e fiksuar dhe afatgjatë për zëvendësimin e dhëmbëve që mungojnë ose janë dëmtuar rëndë. Në Esteva Clinic, çdo rast studiohet me kujdes për të ofruar një trajtim të sigurt, estetik dhe funksional.",
  "implants.benefit1_title": "Materiale Premium",
  "implants.benefit1_desc": "Ne përdorim materiale të zgjedhura me kujdes për të garantuar qëndrueshmëri, biokompatibilitet dhe besueshmëri afatgjatë.",
  "implants.benefit2_title": "Plan i Personalizuar",
  "implants.benefit2_desc": "Çdo pacient merr një vlerësim individual dhe një plan trajtimi të përshtatur sipas nevojave të tij.",
  "implants.benefit3_title": "Estetikë Natyrale",
  "implants.benefit3_desc": "Qëllimi është të arrihen dhëmbë të fiksuar, të bukur dhe natyralë, në harmoni me buzëqeshjen e pacientit.",
  "implants.when_title": "Kur janë të indikuara implante dentare?",
  "implants.when_desc": "Implantet dentare janë të indikuara kur mungon një ose më shumë dhëmbë, kur dhëmbët natyralë nuk mund të shpëtohen më, ose kur proteza e lëvizshme nuk ofron stabilitet dhe komfort.",
  "implants.when_desc2": "Ato mund të përdoren për të zëvendësuar një dhëmb të vetëm, disa dhëmbë ose një hapak të tërë me zgjidhje të fiksuar si All-on-4, All-on-6 ose Toronto Bridge.",
  "implants.path_title": "Rruga jonë e implantit",
  "implants.path_step1_title": "1. Vlerësimi",
  "implants.path_step1_desc": "Analizë e rastit, konsultim me specialistë dhe studim i gjendjes dentare.",
  "implants.path_step2_title": "2. Plani i trajtimit",
  "implants.path_step2_desc": "Krijimi i një plani të personalizuar me kohë, materiale dhe kosto të qarta.",
  "implants.path_step3_title": "3. Vendosja e implantit",
  "implants.path_step3_desc": "Procedura e kryer nga një ekip mjekësor me përvojë në një mjedis të sigurt dhe të kontrolluar.",
  "implants.path_step4_title": "4. Dhëmbë të fiksuar",
  "implants.path_step4_desc": "Krijimi i protezës finale për një buzëqeshje të qëndrueshme, funksionale dhe estetike.",
  "implants.cta_title": "Kërkoni një vlerësim të personalizuar",
  "implants.cta_desc": "Dërgoni një rëntgen panoramik ose na kontaktoni për një vlerësim të parë. Ekipi ynë do t'ju udhëheqë drejt zgjidhjes më të mirë për rastin tuaj.",
  "implants.cta_button": "Rezervoni termin tani",

  "imprint.title": "Informacioni Ligjor",
  "imprint.responsible": "Përgjegjësi për Përmbajtjen",
  "imprint.address_label": "Adresa",
  "imprint.phone_label": "Telefoni",
  "imprint.email_label": "Email",
  "imprint.authorized_label": "Përfaqësuesit e Autorizuar",
  "imprint.register_label": "Regjistri Tregtar",
  "imprint.vat_label": "NIPT",
  "imprint.disclaimer_title": "Përgjegjësia",
  "imprint.disclaimer_text": "Përmbajtja e kësaj faqe interneti krijohet me kujdesin më të madh. Megjithatë, ne nuk mund të garantojmë saktësinë, plotësinë dhe aktualitetin e përmbajtjes. Pavarësisht kontrollit të kujdesshëm të përmbajtjes, ne nuk marrim përgjegjësi për përmbajtjen e lidhjeve të jashtme. Operatorët e faqeve të lidhura janë të vetëm përgjegjës për përmbajtjen e tyre.",
  "imprint.copyright_title": "Të Drejtat e Autorit",
  "imprint.copyright_text": "Përmbajtja dhe veprat e krijuara nga operatorët e faqeve në këto faqe nënshtrohen ligjit të të drejtave të autorit. Riproduktimi, redaktimi, shpërndarja dhe çdo lloj shfrytëzimi jashtë kufijve të të drejtave të autorit kërkojnë miratimin me shkrim të autorit respektiv.",
  "imprint.data_protection_link": "Politika e Privatësisë",

  "booking.find_us": "GJENI NA",
  "booking.visit_us": "Na vizitoni në Tiranë",
  "booking.visit_subtitle": "Klinika jonë ndodhet në zemër të Tiranës. Rezervoni një termin dhe na njihni personalisht.",

  "agb.title": "Kushtet e Shërbimit",
  "agb.meta_desc": "Kushtet e Përgjithshme të Shërbimit të platformës ndërmjetësuese Esteva.ch. Informacion mbi fushën e zbatimit, përgjegjësinë, shërbimet dhe ligjin e zbatueshëm.",

  "hero.discover_prices": "Zbuloni çmimet",

  "services.hero_subtitle": "Tre disiplina, një standard: përsosmeri absolute. Stomatologji, kirurgji plastike dhe transplant flokësh në zemër të Tiranës – deri në 70% më lirë se në DE/AT/CH.",
  "services.page_cta_title": "Gati për transformimin tuaj?",
  "services.page_cta_subtitle": "Rezervoni tani konsultimin tuaj personal në Tiranë. Ekipi ynë i ekspertëve do të krijojë një koncept trajtimi të personalizuar – plotësisht i përshtatur me dëshirat tuaja.",

  "testimonials.hero_subtitle": "Transformime reale, emocione reale. Klientët tanë vijnë nga e gjithë Europa në Tiranë — dhe largohen me ndjesi të reja të jetës.",
  "testimonials.rating": "★ 4.9 / 5.0 — bazuar në mbi 240 vlerësime të verifikuara nga klientët tanë në të gjithë Europën.",
  "testimonials.cta_title": "Bëhuni pjesë e historive tona të suksesit",
  "testimonials.cta_subtitle": "Transformimi juaj fillon me një bisedë. Le të zbulojmë bashkë si mund të theksöjmë bukërinë tuaj natyrore.",

  "about.vision_title": "Një vizion i lindur në Mesdheu",
  "about.vision_para2": "E themeluar nga Dr. Nertila Basha, specialiste ndërkombëtare në mjekësinë estetike, Esteva Clinic bashkon të mirat e dy botëve: saktitét dhe know-how-in e mjekësisë ndërkombëtare të lartë me mikpritjen e ngrohtë dhe autentike ballkanike. Ekipi ynë prej 11 ekspertësh — përfshirë specialistë të kirurgjiës së flokëve, kozmetikës dentare dhe mjekësisë estetike — punon dorë më dorë për të arritur rezultatin optimal për çdo klient.",
  "about.meet_team_link": "Njihuni me ekipin tonë",
  "about.albania_title": "Shqipëria — një vend në rritje",
  "about.albania_subtitle": "Tirana nuk është më sekret. Kryeqyteti shqiptar po zhvillohet me shpejtesi si një nga qendrat më dinamike ekonomike dhe kulturore të Europës Juglindore — dhe Esteva Clinic është në zemër të gjithkahit.",
  "about.albania_card1_title": "Mrekullia ekonomike e Ballkanit",
  "about.albania_card1_desc": "Shqipëria ka regjistruar rritje rekorde prej vitesh. Investimet ndërkombëtare, infrastruktura moderne dhe një popullatsi e re dhe shumë e motivuar e bëjnë Tiranën një pikë të nxehtë për inovacion dhe progres.",
  "about.albania_card2_title": "Natyra që entuziazmojnë",
  "about.albania_card2_desc": "Nga deti Adriatik i gjelbrërt-blu në perndim deri te Alpet Shqiptare madhështore në veri — Shqipëria bashkon lehtesën mesdhetare me madhërinë alpine në hapësirën më të vogël.",
  "about.albania_card3_title": "Magneti i ri i Europës",
  "about.albania_card3_desc": "Gjithnjy e më shumë udhëtarce, nomadë dixhitalë dhe kompani ndërkombëtare po zbulojnë Shqipërinë. Tirana u emërua nga revista Time si një nga qytetet më të emocionueshme të botës.",
  "about.experience_title": "Përjetoni Esteva Clinic vetë",
  "about.experience_subtitle": "Vizitoni na në Tiranë. Ose filloni me një konsultim personal — në vend ose online.",

  "booking.form_name_label": "Emri",
  "booking.form_name_placeholder": "Emri juaj i plotë",
  "booking.form_phone_short": "Telefoni",
  "booking.form_treatment_label": "Trajtimi i dëshiruar",
  "booking.form_message_optional": "Mesazh (opsional)",
  "booking.form_select_please": "Ju lutemi zgjidhni",
  "booking.form_message_short_placeholder": "Mesazhi juaj për ne...",
  "booking.opening_hours_label": "Oraret e Punës",
  "booking.day_mofr": "Hën – Pre",
  "booking.day_saturday": "E shtunë",
  "booking.day_sunday": "E diel",
  "booking.day_closed": "Mbyllur",
  "booking.albania_text": "Shqipëri",

  "contact.hero_tag": "Jemi këtu për ju",
  "contact.hero_title_line1": "Shkruani na.",
  "contact.hero_title_line2": "Përgjigjëmi brenda 24h.",
  "contact.hero_subtitle": "Konsultim falas, kërkesa çmimesh ose thjesht pyetje — ekipi Esteva pret me padurim mesazhin tuaj.",
  "contact.form_title": "Dërgoni një mesazh",
  "contact.form_required_hint": "Të gjitha fushat me * janë të detyrueshme.",
  "contact.firstname_label": "Emri",
  "contact.lastname_label": "Mbiemri",
  "contact.phone_optional": "Telefoni",
  "contact.subject_label": "Tema",
  "contact.subject_placeholder": "Ju lutemi zgjidhni...",
  "contact.subject_dental": "Stomatologji & Implante",
  "contact.subject_surgery": "Kirurgji Plastike",
  "contact.subject_hair": "Transplant Flokësh",
  "contact.subject_general": "Konsultim i Përgjithshëm",
  "contact.subject_price": "Kërkese Çmimi",
  "contact.subject_other": "Tjetër",
  "contact.message_label": "Mesazhi juaj",
  "contact.message_max": "(maks. 500 karaktere)",
  "contact.privacy_contact": "Kam lexuar politiken e privatësisë dhe pranoj që të dhënat e mia të përdoren për të procesuar kërkesen time.",
  "contact.sending": "Duke dërguar...",
  "contact.submit": "Dërgoni mesazhin",
  "contact.success_title": "Faleminderit!",
  "contact.success_message": "Mesazhi juaj u mor. Do t'ju kontaktojmë brenda 24 orëve.",
  "contact.new_message": "Dërgoni një mesazh të ri",
  "contact.info_title": "Informacioni i Kontaktit",
  "contact.follow_us": "Na ndiqni",
  "contact.book_title": "Preferoni direkt?",
  "contact.book_online": "Rezervoni termin online",
  "contact.book_free": "Konsultim falas",
  "contact.maps_open": "Hapeni në Google Maps",
  "contact.find_us_label": "NA GJENI",
  "contact.opening_hours": "Oraret e Punës",
  "contact.address_label": "Adresa",
  "contact.monday_friday": "Hën – Pre",
  "contact.saturday": "E shtunë",
  "contact.sunday": "E diel",
  "contact.closed": "Mbyllur",
  "instagram.followers": "Ndjekësit",
  "instagram.posts": "Postime",
  "instagram.likes_label": "Pëlqime",

  // ══════════════════════════════════════════
  // SEO Meta Tags – multilingual
  // ══════════════════════════════════════════
  "seo.ogLocale": "sq_AL",
  "seo.home.title": "Esteva Clinic – Stomatologji Premium & Kirurgji Plastike | Kozmetikë Dentare & Kirurgji Estetike në Tiranë",
  "seo.home.description": "Esteva Clinic në Tiranë, Shqipëri – Klinika juaj premium për stomatologji dhe kirurgji plastike. Implante dentare, fasa, lifting, rinoplastikë dhe më shumë. Ekip ndërkombëtar ekspertësh. Deri 70% më lirë se në DE/AT/CH. Rezervoni konsultimin tuaj tani.",
  "seo.home.keywords": "Esteva Clinic, stomatologji Tiranë, kirurgji plastike Shqipëri, implante dentare, fasa, lifting, rinoplastikë, zmadhim gjiri, turizëm dentar, kirurgji estetike jashtë, mjekësi estetike Tiranë",
  "seo.about.title": "Rreth Nesh – Esteva Clinic | Klinikë Premium Bukurie në Tiranë, Shqipëri",
  "seo.about.description": "Esteva Clinic në Tiranë, Shqipëri: Historia jonë, filozofia dhe ekipi ynë ndërkombëtar ekspertësh. Zbuloni pse jemi adresa e parë për estetikë premium në zemër të Ballkanit.",
  "seo.about.keywords": "Esteva Clinic Tiranë, stomatologji Shqipëri, kirurgji plastike Tiranë, mjekësi estetike Tiranë, Dr. Nertila Basha, klinikë premium Ballkan, turizëm dentar Shqipëri",
  "seo.services.title": "Shërbimet – Esteva Clinic | Stomatologji, Kirurgji & Transplant Flokësh në Tiranë",
  "seo.services.description": "Shërbimet e Esteva Clinic në Tiranë: Stomatologji premium me implante dentare, fasa, kurora zirkoni, kirurgji plastike dhe transplant flokësh FUE deri 5.000 fasha. Deri 70% më lirë se në DE/AT/CH.",
  "seo.services.keywords": "Stomatologji Tiranë, kirurgji plastike Shqipëri, transplant flokësh Tiranë, transplant FUE, implante dentare, lifting, rinoplastikë, shërbime Esteva Clinic",
  "seo.pricing.title": "Lista e Çmimeve Dentare, Kirurgji & Transplant Flokësh – Esteva Clinic Tiranë | Kosto Transparente",
  "seo.pricing.description": "Lista e plotë e çmimeve të Esteva Clinic Tiranë: Implante dentare nga 350 €, rinoplastikë nga 2.200 €, transplant flokësh FUE nga 1.500 €. Të gjitha çmimet me hotel, taksi dhe skanim 3D të përfshirë.",
  "seo.pricing.keywords": "Çmimet Esteva Clinic, listë çmimesh dentare Tiranë, kosto implantesh dentare, çmime kirurgjie plastike Shqipëri, kosto transplant flokësh, transplant FUE, kosto rinoplastike, çmim zmadhimi gjiri",
  "seo.testimonials.title": "Dëshmitë – Esteva Clinic | Përvoja Reale Klientësh nga Tirana",
  "seo.testimonials.description": "Dëshmi reale nga klientët e Esteva Clinic: Stomatologji dhe kirurgji plastike në Tiranë. Lexoni pse klientët tanë vijnë nga e gjithë Europa – deri 70% më lirë.",
  "seo.testimonials.keywords": "Dëshmi Esteva Clinic, përvoja stomatologjie, dëshmi kirurgjie plastike, vlerësime lifting, përvoja implantesh dentare, dëshmi mjekësie estetike",
  "seo.booking.title": "Rezervoni Termin – Esteva Clinic | Konsultim në Tiranë",
  "seo.booking.description": "Rezervoni konsultimin tuaj personal në Esteva Clinic në Tiranë. Stomatologji, kirurgji plastike dhe mjekësi estetike. Konsultimi i parë falas – deri 70% më lirë se në DE/AT/CH.",
  "seo.booking.keywords": "Konsultim Tiranë, rezervim Esteva Clinic, termin stomatologjie, konsultim kirurgjie plastike, konsultim lifting, konsultim implantesh dentare, rezervim klinikë bukurie",
  "seo.gallery.title": "Galeria – Esteva Clinic | Rezultate Para & Pas nga Tirana",
  "seo.gallery.description": "Rezultate mbresëlënëse para dhe pas nga Esteva Clinic në Tiranë: Implante dentare, fasa, lifting, rinoplastikë dhe më shumë. Rezultate reale nga klientë realë nga e gjithë Europa.",
  "seo.gallery.keywords": "Galeri para pas, rezultate stomatologjie, rezultate fasash, transformime lifting, rezultate rinoplastike, Esteva Clinic, imazhe mjekësie estetike",
  "seo.team.title": "Ekipi – Esteva Clinic | Ekip Ndërkombëtar Ekspertësh në Tiranë",
  "seo.team.description": "Njihuni me ekipin ndërkombëtar të ekspertëve të Esteva Clinic në Tiranë. Specialistë në stomatologji, kirurgji plastike dhe mjekësi estetike. Shumëgjuhësh, me përvojë, të pasionuar.",
  "seo.team.keywords": "Ekipi Esteva Clinic, Esteva Clinic Tiranë, kirurgë plastikë Tiranë, ekspertë stomatologjie Shqipëri, specialistë dentarë, mjekë kirurgjie estetike",
  "seo.contact.title": "Kontakti – Esteva Clinic | Kërkoni një Konsultim në Tiranë",
  "seo.contact.description": "Kontaktoni Esteva Clinic në Tiranë. Konsultim falas për stomatologji, kirurgji plastike dhe transplant flokësh. Dërgoni kërkesën tuaj tani!",
  "seo.contact.keywords": "Kontakt Esteva Clinic, konsultim Tiranë, kërkesë stomatologjie, konsultim kirurgjie Shqipëri",
  "seo.imprint.title": "Informacion Ligjor – Esteva Clinic | Rruga Bylis, Tiranë 1001, Shqipëri",
  "seo.imprint.description": "Informacion ligjor i Esteva Clinic Tiranë. Informacion ligjor, përgjegjës, adresa dhe të dhëna kontakti të Esteva Clinic në Shqipëri.",
  "seo.imprint.keywords": "Informacion ligjor, Esteva Clinic, Tiranë, Shqipëri, informacion ligjor, kontakt Esteva Clinic",
  "seo.dental_implants.title": "Implante Dentare Premium – Esteva Clinic | Stomatologji Tiranë",
  "seo.dental_implants.description": "Implante dentare premium në Tiranë, Shqipëri. Zgjidhje moderne, të sigurta dhe të personalizuara për implante. Deri 70% më lirë se në DE/AT/CH. Kërkoni konsultimin tuaj falas.",
  "seo.dental_implants.keywords": "Implante dentare Tiranë, implante dentare Shqipëri, kosto implantesh, All-on-4 Tiranë, All-on-6 Shqipëri, Esteva Clinic implante",
  "seo.agb.keywords": "Kushtet, Esteva Clinic, kushte, Esteva.ch",

  // ══════════════════════════════════════════
  // Politika e Privatësisë
  // ══════════════════════════════════════════
  "privacy.title": "Politika e Privatësisë",
  "privacy.subtitle": "Esteva.ch — Platformë Ndërmjetësimi për Shërbime Mjekësore dhe Estetike",
  "privacy.date": "Përditësuar: 11 qershor 2026",
  "privacy.last_updated": "Përditësimi i fundit",
  "privacy.s1_title": "1. Përgjegjësi i Trajtimit",
  "privacy.s1_text": "Përgjegjësi për trajtimin e të dhënave në këtë platformë është:\n\nAI Vision GmbH\nUnterdorf 8, 8222 Beringen, Zvicër\nEmail: info@esteva.ch\n(Ndërmjetës / Operator i Platformës)\n\nBashkëpërgjegjës për trajtimin e kërkesave tuaja mjekësore:\nNertila Basha\nEuromed Dental Maxillofacial & Aesthetic Center\nRruga Bylis, Tiranë 1001, Shqipëri\n\nKjo politikë privatësie zbatohet në përputhje me Ligjin Federal Zviceran për Mbrojtjen e të Dhënave (LPD/nLPD) dhe, kur është e zbatueshme, me Rregulloren e Përgjithshme të Mbrojtjes së të Dhënave të BE-së (GDPR).",
  "privacy.s2_title": "2. Cilat të Dhëna Mbledhim",
  "privacy.s2_text": "Ne mbledhim kategoritë e mëposhtme të të dhënave personale:\n\n• Të dhëna kontakti: emri, adresa email, numri i telefonit\n• Kërkesat dhe konsultimet për trajtim (të dhëna vullnetarisht nga ju)\n• Të dhëna teknike: adresa IP, lloji i shfletuesit, koha e vizitës, faqet e vizituara\n• Të dhëna komunikimi: mesazhe përmes formularëve të kontaktit ose WhatsApp\n\nNe nuk mbledhim kategori të veçanta të dhënash personale (p.sh. të dhëna shëndetësore) pa pëlqimin tuaj të shprehur.",
  "privacy.s3_title": "3. Qëllimi i Trajtimit të të Dhënave",
  "privacy.s3_text": "Të dhënat tuaja përdoren ekskluzivisht për qëllimet e mëposhtme:\n\n• Ndërmjetësimi te ofruesi i dëshiruar i shërbimit (klinika)\n• Përgjigjja ndaj kërkesave dhe caktimi i takimeve\n• Përmirësimi i platformës dhe administrimi teknik\n• Pajtueshmëria me detyrimet ligjore",
  "privacy.s4_title": "4. Ndarja e të Dhënave",
  "privacy.s4_text": "4.1 Të dhënat tuaja të kontaktit dhe kërkesa për trajtim do t'i përcillen ofruesit të shërbimit që keni zgjedhur (klinikë në Shqipëri) në mënyrë që ai të përpunojë kërkesën tuaj.\n\n4.2 Ne nuk ua japim të dhënat tuaja palëve të treta për qëllime tregtare.\n\n4.3 Transferimi i të dhënave jashtë vendit (Shqipëri) bazohet në pëlqimin tuaj. Shqipëria nuk konsiderohet si një vend me nivel të barabartë mbrojtjeje të të dhënave me atë zviceran; transferimi bazohet në pëlqimin tuaj të shprehur në përputhje me Art. 17 nLPD.",
  "privacy.s5_title": "5. Cookies dhe Gjurmimi",
  "privacy.s5_text": "5.1 Platforma jonë përdor cookies teknikisht të nevojshëm për funksionimin e faqes së internetit.\n\n5.2 Ne mund të përdorim mjete analitike (p.sh. Google Analytics). Ju mund të kundërshtoni përdorimin e cookies analitikë në çdo kohë.\n\n5.3 Ju mund të çaktivizoni cookies në cilësimet e shfletuesit tuaj; kjo mund të kufizojë funksionalitetin e platformës.",
  "privacy.s6_title": "6. Periudha e Ruajtjes",
  "privacy.s6_text": "Ne ruajmë të dhënat tuaja personale vetëm për aq kohë sa është e nevojshme për qëllimet e përmendura. Të dhënat e kërkesave do të fshihen pas maksimumi 2 vjetësh.",
  "privacy.s7_title": "7. Të Drejtat Tuaja",
  "privacy.s7_text": "Ju keni të drejtat e mëposhtme në lidhje me të dhënat tuaja personale:\n\n• E drejta e aksesit: informacion mbi të dhënat e ruajtura\n• E drejta e korrigjimit: korrigjimi i të dhënave të pasakta\n• E drejta e fshirjes: fshirja e të dhënave tuaja përveçse kur ka detyrime ligjore\n• E drejta e kundërshtimit: kundërshtimi i trajtimit të të dhënave\n• E drejta e transportueshmërisë: marrja e të dhënave tuaja në një format të zakonshëm\n\nPër të ushtruar të drejtat tuaja: info@esteva.ch\n\nAnkesat mund të paraqiten pranë Komisionerit Federal Zviceran për Mbrojtjen e të Dhënave dhe Transparencën (PFPDT): www.edoeb.admin.ch",
  "privacy.s8_title": "8. Siguria e të Dhënave",
  "privacy.s8_text": "Ne marrim masa teknike dhe organizative të përshtatshme për të mbrojtur të dhënat tuaja personale (p.sh. kriptimi SSL/TLS).",
  "privacy.s9_title": "9. Shërbime të Palëve të Treta",
  "privacy.s9_text": "Platforma mund të përdorë shërbimet e mëposhtme të palëve të treta:\n\n• Google Maps — Politika e privatësisë: policies.google.com/privacy\n• WhatsApp Business — Politika e privatësisë: www.whatsapp.com/legal/privacy-policy",
  "privacy.s10_title": "10. Ndryshimet e Kësaj Politike",
  "privacy.s10_text": "Ne rezervojmë të drejtën të ndryshojmë këtë politikë privatësie në çdo kohë. Versioni aktual është i disponueshëm në www.Esteva.ch.\n\nAI Vision GmbH | Unterdorf 8, 8222 Beringen | info@esteva.ch | www.Esteva.ch",

  // SEO
  "seo.privacy.title": "Politika e Privatësisë – Esteva.ch | AI Vision GmbH, Beringen, Zvicër",
  "seo.privacy.description": "Politika e privatësisë së platformës ndërmjetësuese Esteva.ch. Informacion mbi mbledhjen, trajtimin dhe ndarjen e të dhënave personale në përputhje me LPD/nLPD zvicerane dhe GDPR të BE-së. Përgjegjësi i trajtimit: AI Vision GmbH, Beringen, Zvicër.",
  "seo.privacy.keywords": "Politika e privatësisë, Esteva.ch, AI Vision GmbH, mbrojtja e të dhënave, LPD, nLPD, GDPR, të dhëna personale, Beringen, Zvicër",

  // ══════════════════════════════════════════
  // Admin-Dashboard
  // ══════════════════════════════════════════
  "admin.logo": "ESTEVA ADMIN",
  "admin.to_website": "Shko te Faqja",
  "admin.logout": "Dilni",
  "admin.sidebar_expand": "Hap menynë",
  "admin.sidebar_collapse": "Mbyll menynë",
  "admin.nav_dashboard": "Përmbledhje",
  "admin.nav_pages": "Faqe & Përmbajtje",
  "admin.nav_treatments": "Trajtime & Çmime",
  "admin.nav_team": "Ekipi",
  "admin.nav_reviews": "Vlerësimet",
  "admin.nav_bookings": "Rezervime & Termine",
  "admin.nav_media": "Imazhe & Media",
  "admin.nav_translations": "Gjuhë & Përkthime",
  "admin.nav_footer": "Footer & Kontakt",
  "admin.nav_seo": "SEO",
  "admin.nav_settings": "Cilësimet",
  "admin.breadcrumb_admin": "Admin",
  "admin.header_settings": "Cilësimet",

  "admin.dashboard_title": "Paneli",
  "admin.dashboard_welcome": "Mirë se u kthyet! Ja përmbledhja juaj.",
  "admin.stat_bookings": "Rezervime",
  "admin.stat_bookings_sub": "{{count}} të reja",
  "admin.stat_confirmed": "Konfirmuara",
  "admin.stat_confirmed_sub": "aktive",
  "admin.stat_today": "Sot",
  "admin.stat_today_sub": "Termine",
  "admin.stat_treatments": "Trajtime",
  "admin.stat_treatments_sub": "Lista çmimesh",
  "admin.stat_team": "Ekipi",
  "admin.stat_team_sub": "Anëtarë",
  "admin.stat_reviews": "Vlerësime",
  "admin.stat_reviews_sub": "Dëshmi klientësh",

  "admin.upcoming_title": "Terminet e Ardhshme",
  "admin.today_label": "Sot",
  "admin.upcoming_label": "Së shpejti",
  "admin.no_future_bookings": "Nuk ka termine të tjera të planifikuara.",
  "admin.view_all": "Shiko të gjitha",

  "admin.status_new": "E re",
  "admin.status_confirmed": "Konfirmuar",
  "admin.status_done": "Kryer",

  "admin.activity_title": "Aktivitetet e Fundit",
  "admin.activity_empty": "Ende pa aktivitete.",
  "admin.activity_just_now": "tani sapo",
  "admin.activity_min_ago": "{{count}} min më parë",
  "admin.activity_hour_ago": "{{count}} orë më parë",
  "admin.activity_day_ago": "{{count}} ditë më parë",
  "admin.activity_days_ago": "{{count}} ditë më parë",

  "admin.quick_title": "Qasje e Shpejtë",
  "admin.quick_home": "Ndrysho Faqen Kryesore",
  "admin.quick_bookings": "Menaxho Rezervimet",
  "admin.quick_pricing": "Ndrysho Listën e Çmimeve",
  "admin.quick_team": "Menaxho Ekipin",

  "admin.service_hair": "Transplant Flokësh",
  "admin.service_dental": "Kozmetikë Dentare",
  "admin.service_botox": "Botox & Filler",
  "admin.service_combined": "Trajtim i Kombinuar",
  "admin.service_consultation": "Konsultim",

  "team.nertila-basha.title": "CEO, Dentiste, Implantologe & Protetiste",
  "team.nertila-basha.specialty": "Implante dentare & Protetikë estetike",
  "team.nertila-basha.bio": "Dr. Nertila Basha është CEO, dentiste, implantologe dhe protetiste me përvorjë të gjerë në fushen dentare. Dallohet për saktitett klinike dhe këjdes ndaj detajeve, duke ofruar trajtime moderne dhe të personalizuara për çdo pacient. Qëllimi i saj është të garantojë rezultate funksionale dhe estetike në nivelin më të lartë, duke vendösur gjithmonë shëndetin dhe mirëqqenien e pacientit në qendër.",
  "team.nertila-basha.certifications": ["Specialistë në Stomatologji", "Implantologji & Protetikë", "Universiteti i Tiranës"],

  "team.denisa-zhegu.title": "Mjeke e Mjeksisë Estetike",
  "team.denisa-zhegu.specialty": "Trajtime dermo-estetike",
  "team.denisa-zhegu.bio": "Dr. Denisa Zhegu është mjeke e mjeksisë estetike me formim ndërkombëtar, e specializuar në trajtime dermo-estetike të avancuara. Dallohet për përdorimin e teknikave moderne dhe të sigurta, duke ofruar rezultate natyrale dhe të personalizuara për çdo pacient. Falendërit përvorjës dhe formimit të vazhdueshem, është nje figue kyqe në mjeksinë estetike në Tiranë.",
  "team.denisa-zhegu.certifications": ["Specialistë Mjeksi Estetike", "Certifikim Dermo-estetik", "Akademia Ndërkombëtare"],

  "team.nuri-qyra.title": "Anestezist & Intensivist",
  "team.nuri-qyra.specialty": "Anestezi & Siguria e Pacientit",
  "team.nuri-qyra.bio": "Specialist me mbi 40 vjet përvorjë në anestezi dhe këjdesje intensive, i dëdikuar sigurisë, monitorimit dhe rehatit maksimal të pacientit gjatë çdo procedure mjekësore dhe kirurgjikale. Qetsia dhe ekspertiza e tij u japin siguri po aqë pacientave ashtu edhe ekipit.",
  "team.nuri-qyra.certifications": ["Specialist në Anestezi", "Mjeksi Intensive", "Universiteti i Tiranës"],

  "team.nurie-paloka.title": "Infermiere Kryesore e Sallës Operacionale",
  "team.nurie-paloka.specialty": "Asistencë Kirurgjikale & Menaxhim i Sallës Operacionale",
  "team.nurie-paloka.bio": "Me 37 vjet përvorjë në asistencën kirurgjikale dhe menaxhimin e sallës operacionale, i përkushtuar nivelit më të lartë të profesionalizmit, organizimit dhe këjdesjes ndaj pacientit gjatë çdo procedure mjekësore. Koordinon tërë zhvillimin e operacionit me saktitett dhe zemrë.",
  "team.nurie-paloka.certifications": ["Infermiere Kryesore e Sallës Operacionale", "Asistencë Kirurgjikale", "Menaxhim Klinike"],

  "team.ermir-mehillej.title": "Kirurg Implantolog",
  "team.ermir-mehillej.specialty": "Implantologji dentare & Kirurgji",
  "team.ermir-mehillej.bio": "Dr. Ermir Mehillej është dentist dhe implantolog kirurgjik me 8 vjet përvorjë në fushë. Është i specializuar në implantologjinë tradicionale, implantet pterygoide dhe zigomatike, duke trajtuar edhe rastet më komplekse me saktitett dhe kompetencë. Falendërit përvorjës së gjatë, ofron zgjidhje të sigurta, funksionale dhe estetikisht të avancuara për çdo pacient.",
  "team.ermir-mehillej.certifications": ["Specialist në Stomatologji", "Kirurgji Implantologjike", "Implantet Zigomatike & Pterygoide"],

  "team.roel-ferataj.title": "Kirurg Implantolog",
  "team.roel-ferataj.specialty": "Implantologji dentare & Kirurgji",
  "team.roel-ferataj.bio": "Dr. Roel Ferataj është dentist dhe implantolog kirurgjik me 4 vjet përvorjë në fushë. Është i specializuar në implantologjinë tradicionale, implantet pterygoide dhe zigomatike dhe dallohet për saktitett dhe këjdes në çdo trajtim, edhe në rastet më komplekse. Me nje qasje profesionale dhe vëmendje të madhe ndaj nevojave të pacientit ofron zgjidhje moderne, të sigurta dhe estetikisht harmonike.",
  "team.roel-ferataj.certifications": ["Specialist në Stomatologji", "Kirurgji Implantologjike", "Implantologji e Avancuar"],

  "team.ana-bardhi.title": "Dentiste – Protetikë & Endodonci",
  "team.ana-bardhi.specialty": "Protetikë, Endodonci & Rehabilitim Estetik",
  "team.ana-bardhi.bio": "Dr. Ana Bardhi është specialistë në protetikën dentare dhe endodonci me 6 vjet përvorjë klinike. Këjdeset për rehabilitimin estetik dhe funksional të buzeqëshjes, duke ofruar trajtime të personalizuara dhe zgjidhje moderne për çdo pacient. Falendërit profesionalizmit dhe këjdesit ndaj detajeve garanton trajtime të larta cilësëbe në nje mjedis mirëpritës dhe të sigurt.",
  "team.ana-bardhi.certifications": ["Specialistë në Protetikë", "Specialistë në Endodonci", "Stomatologji Estetike"],

  "team.rigers-xaka.title": "Asistent Dentar",
  "team.rigers-xaka.specialty": "Asistencë Klinike & Këjdjes ndaj Pacientit",
  "team.rigers-xaka.bio": "Rigers Xaka është asistent dentar me 2 vjet përvorjë në fushën dentare. Mbeshtet ekipin mjekësor gjatë procedurave klinike dhe kontribuon në garantimin e nje mjedisi të organizuar, të sigurt dhe mirëpritës për pacientët. Falendërit profesionalizmit dhe vëmendjes ndaj detajeve sigaron asistencë efikase në çdo fazë të trajtimit.",
  "team.rigers-xaka.certifications": ["Asistent Dentar", "Mbeshtetje Klinike", "Menaxhim Pacientësh"],

  "team.luciana-basha.title": "Endodontiste",
  "team.luciana-basha.specialty": "Trajtim kanalesh rrenjore & Ruajtja e dhëmbëve natyralë",
  "team.luciana-basha.bio": "Mjeke endodontiste me 3 vjet përvorjë në trajtimet e kanaleve rrenjore dhe ruajtjen e dhëmbëve natyralë. I përkushtohet trajtimeve të sakta, minimalisht invazive dhe pa dhimbje, përdor teknika moderne dhe vendos gjithmonë rehatin dhe shëndetin e pacientit në vend të parë.",
  "team.luciana-basha.certifications": ["Specialistë në Endodonci", "Specialistë në Kanalin e Rrenzores", "Universiteti i Tiranës"],

  "team.gezim-kabashi.title": "Shofer & Asistencë Pacientësh",
  "team.gezim-kabashi.specialty": "Mbeshtetje Organizative & Transport",
  "team.gezim-kabashi.bio": "I specializuar në këjdesjen e plotë të pacientave gjatë gjithë qendrimit të tyre në Shqipëri. Ofron mbeshtetje organizative, komunikim profesional dhe nje përvorjë të rehatshem qe nga momenti i mbrritjes deri në fund të trajtimit.",
  "team.gezim-kabashi.certifications": ["Këjdjes Pacientësh", "Shofer", "Menaxhim Organizativ"],

  "team.griselda.title": "Koordinatore e Klinikes",
  "team.griselda.specialty": "Menaxhim Klinike & Koordinim Pacientësh",
  "team.griselda.bio": "Griselda është koordinatorja e klinikes me më shumë se 10 vjet përvorjë në menaxhimin dhe koordinimin e klinikave dhe struktave spitalore. Falendërit aftësive organizative dhe vëmendjes ndaj pacientëve garanton nje rrjedhë trajtimi efikase, profesionale dhe mirë të organizuar. Është pika e kontaktit për këjdesjen dhe mbeshtetjen e pacientëve gjatë të gjitha fazave të trajtimit.",
  "team.griselda.certifications": ["Menaxhim Klinike", "Koordinim Pacientësh", "Administrim Shëndetësor"],
  "home.seo_service_areas_label": "Zonat e shërbimit & trajtimet",
  "home.instagram_error": "Postimet e Instagram nuk mund të ngarkoheshin.",
  "home.instagram_retry": "Provo përsëri",
  "home.instagram_empty_title": "Ende nuk ka postime.",
  "home.instagram_empty_subtitle": "Na ndiqni në Instagram për pamje ekskluzive.",
  "home.booking_reception_alt": "Recepsioni i Esteva Clinic",
  "home.newsletter_exists": "Ky email është regjistruar tashmë.",
  "home.newsletter_error": "Ndodhi një gabim. Ju lutemi provoni përsëri.",
  "home.developed_by": "Zhvilluar nga",
  "svc.pricing_hero_tag": "Lista e çmimeve",
  "svc.savings_tag": "Krahasimi i çmimeve",
  "svc.savings_title": "Ja sa kurseni në krahasim",
  "svc.savings_subtitle": "E njëjta cilësi, teknologji moderne — me një pjesë të vogël të kostos në Gjermani, Austri ose Zvicër.",
  "svc.savings_col_treatment": "Trajtimi",
  "svc.savings_col_savings": "Kursimi",
  "svc.packages_tag": "Paketat e trajtimit",
  "svc.faq_heading": "Pyetjet e bëra shpesh",
  "svc.pricing_cta_subtitle": "Ende të pasigurt se cili trajtim është i duhuri për ju? Në një konsultë personale do të gjejmë së bashku zgjidhjen ideale.",
  "svc.pricing_faq1_q": "Çfarë përfshihet në paketat e çmimeve?",
  "svc.pricing_faq1_a": "Çdo paketë përfshin trajtimet e përmendura si dhe kujdesin pasues të specifikuar. Në një konsultë personale sqarojmë të gjitha detajet dhe e përshtatim paketën pikërisht sipas nevojave tuaja individuale.",
  "svc.pricing_faq2_q": "A ka kosto të fshehura?",
  "svc.pricing_faq2_a": "Jo. Tek Esteva Clinic transparenca është në radhë të parë. Çmimi i rënë dakord gjatë konsultës është i detyrueshëm. Nuk ka kosto shtesë të fshehura.",
  "svc.pricing_faq3_q": "A mund t'i kombinoj trajtimet?",
  "svc.pricing_faq3_a": "Sigurisht. Shumë nga klientët tanë dëshirojnë një kombinim trajtimesh të ndryshme. Kombinimet individuale i diskutojmë me kënaqësi gjatë konsultës.",
  "svc.pricing_faq4_q": "Cilat metoda pagese pranoni?",
  "svc.pricing_faq4_a": "Pranojmë karta krediti (Visa, Mastercard, American Express), transfertë bankare si dhe pagesë me këste përmes partnerit tonë. Detajet do t'i merrni gjatë një bisede personale.",
  "svc.pricing_faq5_q": "Sa zgjat kujdesi pasues?",
  "svc.pricing_faq5_a": "Kujdesi pasues ndryshon në varësi të trajtimit. Të gjitha takimet pasuese zhvillohen në klinikën tonë në Tiranë. Një plan i detajuar hartohet gjatë konsultës suaj.",
  "svc.price_from": "nga ",
  "svc.price_fixed": "Çmim fiks",
  "svc.view_details_link": "Shiko detajet",
  "svc.dental_subtitle": "Çmime fikse transparente për të gjitha trajtimet dentare — përfshirë teknologjinë moderne dhe specialistë me përvojë.",
  "svc.dental_cat_implants_label": "Implantet",
  "svc.dental_cat_crowns_label": "Kurorat & Urat",
  "svc.dental_cat_aesthetics_label": "Estetika & Aparatet dentare",
  "svc.dental_cat_bone_label": "Shtimi i kockës",
  "svc.dental_cat_prosthetics_label": "Protetika",
  "svc.dental_cat_implants_desc": "Implantet moderne nga materiale cilësore për një kafshim të fortë gjatë gjithë jetës.",
  "svc.dental_cat_crowns_desc": "Kurora me estetikë të lartë nga zirkoni ose qeramika — të përshtatura në mënyrë perfekte me ngjyrën e dhëmbëve tuaj.",
  "svc.dental_cat_aesthetics_desc": "Buzëqeshja juaj më e bukur: nga pastrimi profesional deri te aparati i padukshëm dentar.",
  "svc.dental_cat_bone_desc": "Trajtimet paraprake të nevojshme për një ankorim të sigurt të implantit në nofull.",
  "svc.dental_cat_prosthetics_desc": "Kujdes protetik fleksibël dhe komod për një cilësi më të mirë jete.",
  "svc.surgery_subtitle": "Kirurgji plastike dhe estetike në nivelin më të lartë — përfshirë të gjithë kujdesin para dhe pas ndërhyrjes në Tiranë.",
  "svc.surgery_cat_face_label": "Fytyra & Lifting",
  "svc.surgery_cat_breast_label": "Kirurgjia e gjirit",
  "svc.surgery_cat_body_label": "Modelimi i trupit",
  "svc.surgery_cat_special_label": "Procedura speciale",
  "svc.surgery_cat_face_desc": "Kirurgjia estetike më e rafinuar për një profil të harmonishëm e natyral të fytyrës.",
  "svc.surgery_cat_breast_desc": "Përmasa natyralisht të bukura përmes teknikave moderne kirurgjikale dhe implanteve Mentor.",
  "svc.surgery_cat_body_desc": "Kontura të përcaktuara të trupit: nga liposuksioni deri te shtrëngimi i plotë.",
  "svc.surgery_cat_special_desc": "Procedura speciale inovative për dëshirat tuaja individuale.",
  "svc.hair_subtitle": "Teknika moderne FUE me tehe safiri — flokë natyralisht të dendur, pa mbetje shenjash dhe gjatë gjithë jetës.",
  "svc.hair_bestseller": "Më i shituri",
  "svc.hair_treatment_label": "Trajtimi",
  "svc.hair_total_price": "Çmimi total",
  "svc.hair_all_inclusive": "Paketë gjithëpërfshirëse",
  "svc.hair_graft_overview": "Paketat e graftëve me një vështrim",
  "svc.hair_popular": "Popullor",
  "svc.hair_ideal_for": "Ideal për:",
  "svc.hair_included_title": "Përfshirë në paketën gjithëpërfshirëse",
  "svc.hair_none_available": "Nuk ka trajtime të transplantimit të flokëve në dispozicion.",
  "svc.hair_tech_method_label": "Metoda",
  "svc.hair_tech_method_value": "FUE (Follicular Unit Extraction) — pa shenja",
  "svc.hair_tech_grafts_label": "Graftë",
  "svc.hair_tech_grafts_value": "Deri në 5.000 graftë në një seancë të vetme",
  "svc.hair_tech_duration_label": "Kohëzgjatja",
  "svc.hair_tech_duration_value": "6–8 orë (një takim)",
  "svc.hair_tech_anesthesia_label": "Anestezia",
  "svc.hair_tech_anesthesia_value": "Anestezi lokale me qetësues",
  "svc.hair_tech_guarantee_label": "Garancia",
  "svc.hair_tech_guarantee_value": "Rezultat i dendur gjatë gjithë jetës",
  "svc.hair_tech_return_label": "Udhëtimi i kthimit",
  "svc.hair_tech_return_value": "E mundur që nga dita e 3-të pas operacionit",
  "svc.hair_incl_1": "Konsultë personale &amp; analizë e flokëve",
  "svc.hair_incl_2": "Analizë gjaku &amp; kontroll shëndetësor",
  "svc.hair_incl_3": "Trajtim FUE me tehe safiri",
  "svc.hair_incl_4": "PRP (plazma e pasur me trombocite) për të nxitur shërimin",
  "svc.hair_incl_5": "Set special shamponi për kujdesin pasues",
  "svc.hair_incl_6": "Të gjitha kontrollet pasuese në Tiranë",
  "svc.hair_graft1_count": "Deri në 2.000",
  "svc.hair_graft1_desc": "Hapësira të vogla &amp; tërheqje e vijës së flokëve",
  "svc.hair_graft1_ideal": "Rënie e lehtë e flokëve",
  "svc.hair_graft2_desc": "Zona e përparme &amp; kurora",
  "svc.hair_graft2_ideal": "Rënie mesatare e flokëve",
  "svc.hair_graft3_desc": "Rivendosje e plotë",
  "svc.hair_graft3_ideal": "Rënie e avancuar e flokëve",
  "svc.detail_not_found": "Trajtimi nuk u gjet",
  "svc.detail_back_home": "Kthehu te faqja kryesore",
  "info.map_title": "Harta e vendndodhjes së Esteva Clinic",
  "info.hero_image_alt": "Rezervimi i terminit në Esteva Clinic",
  "legal.location_title": "Vendndodhja",
  "legal.notfound_seo_title": "Faqja nuk u gjet – Esteva Clinic",
  "legal.notfound_seo_description": "Faqja e kërkuar nuk u gjet. Kthehuni te faqja kryesore e Esteva Clinic.",
  "legal.notfound_title": "Kjo faqe nuk u gjet",
  "legal.notfound_subtitle": "Faqja që po kërkoni nuk ekziston.",
  "adm1.service_surgery": "Kirurgji",
  "adm1.saved": "U ruajt!",
  "adm1.save_error": "Gabim gjatë ruajtjes",
  "adm1.save_error_dot": "Gabim gjatë ruajtjes.",
  "adm1.save": "Ruaj",
  "adm1.cancel": "Anulo",
  "adm1.delete": "Fshi",
  "adm1.refresh": "Rifresko",
  "adm1.retry": "Provo përsëri",
  "adm1.filter_all": "Të gjitha",
  "adm1.filter_visible": "Të dukshme",
  "adm1.filter_hidden": "Të fshehura",
  "adm1.action_edit": "Modifiko",
  "adm1.action_delete": "Fshi",
  "adm1.action_hide": "Fshih",
  "adm1.action_show": "Shfaq",
  "adm1.delete_irreversible": "Ky veprim nuk mund të zhbëhet.",
  "adm1.label_name": "Emri",
  "adm1.label_email": "Email",
  "adm1.label_phone": "Telefoni",
  "adm1.label_package": "Paketa",
  "adm1.label_treatment": "Trajtimi",
  "adm1.label_status": "Statusi:",
  "adm1.label_location": "Vendndodhja",
  "adm1.label_date": "Data",
  "adm1.label_rating": "Vlerësimi",
  "adm1.label_text": "Teksti",
  "adm1.label_visible": "E dukshme",
  "adm1.label_verified": "E verifikuar",
  "adm1.bookings_title": "Rezervimet dhe takimet",
  "adm1.bookings_summary": "{{total}} rezervime · {{new}} të reja · {{confirmed}} të konfirmuara · {{done}} të përfunduara",
  "adm1.bookings_load_error": "Gabim gjatë ngarkimit të rezervimeve.",
  "adm1.bookings_status_error": "Statusi nuk u përditësua dot.",
  "adm1.bookings_saved_notified": "U ruajt! Klienti do të njoftohet.",
  "adm1.bookings_loading": "Po ngarkohen rezervimet...",
  "adm1.bookings_empty_title": "Nuk u gjet asnjë rezervim.",
  "adm1.bookings_empty_desc": "Rezervimet e reja shfaqen këtu sapo pacientët kërkojnë një takim përmes formularit të faqes.",
  "adm1.reviews_title": "Vlerësimet",
  "adm1.reviews_summary": "{{total}} vlerësime · {{visible}} të dukshme",
  "adm1.reviews_new": "Vlerësim i ri",
  "adm1.reviews_edit": "Modifiko vlerësimin",
  "adm1.reviews_empty_title": "Ende nuk ka vlerësime.",
  "adm1.reviews_empty_desc": "Klikoni \"Vlerësim i ri\" për të shtuar dëshminë e parë të klientit.",
  "adm1.reviews_delete_confirm": "Të fshihet vlerësimi?",
  "adm1.team_title": "Ekipi",
  "adm1.team_count": "{{count}} anëtarë të ekipit",
  "adm1.team_new": "Anëtar i ri",
  "adm1.team_edit": "Modifiko anëtarin",
  "adm1.team_delete_confirm": "Të fshihet anëtari?",
  "adm1.label_title_role": "Titulli / Roli",
  "adm1.ph_title_role": "p.sh. CEO, dentiste",
  "adm1.label_specialty": "Fusha e specializimit",
  "adm1.ph_specialty": "p.sh. implante dhëmbësh",
  "adm1.label_bio": "Bio",
  "adm1.label_certifications": "Certifikatat (të ndara me presje)",
  "adm1.ph_certifications": "p.sh. specialist stomatologjie, implantologji",
  "adm1.label_languages": "Gjuhët (të ndara me presje, p.sh. DE, EN, IT)",
  "adm1.label_photo": "Foto",
  "adm1.label_order": "Renditja (numri)",
  "adm1.treatments_title": "Trajtimet dhe çmimet",
  "adm1.treatments_summary": "{{count}} trajtime · çmimet në €",
  "adm1.treatments_import": "Importo trajtimet e parazgjedhura",
  "adm1.treatments_new": "Trajtim i ri",
  "adm1.treatments_edit": "Modifiko trajtimin",
  "adm1.treatments_empty": "Nuk ka trajtime në këtë kategori.",
  "adm1.treatments_delete_confirm": "Të fshihet trajtimi?",
  "adm1.importing": "Po importohet…",
  "adm1.import_error": "Gabim gjatë importimit",
  "adm1.col_treatment": "Trajtimi",
  "adm1.col_category": "Kategoria",
  "adm1.col_price_al": "Çmimi AL",
  "adm1.col_price_de": "Çmimi DE",
  "adm1.col_price_at": "Çmimi AT",
  "adm1.col_price_ch": "Çmimi CH",
  "adm1.col_savings": "Kursimi",
  "adm1.ph_treatment_name": "Emri i trajtimit",
  "adm1.label_description": "Përshkrimi",
  "adm1.ph_description": "Përshkrimi...",
  "adm1.label_price_al": "Çmimi Shqipëri (€)",
  "adm1.label_price_de": "Çmimi DE (€)",
  "adm1.label_price_at": "Çmimi AT (€)",
  "adm1.label_price_ch": "Çmimi CH (€)",
  "adm1.ph_price_range": "p.sh. 1.500 – 2.000",
  "adm1.label_savings_percent": "Kursimi (%)",
  "adm1.settings_title": "Cilësimet",
  "adm1.settings_subtitle": "Menaxho cilësimet globale të faqes.",
  "adm1.settings_general": "Të përgjithshme",
  "adm1.settings_colors": "Ngjyrat",
  "adm1.settings_change_password": "Ndrysho fjalëkalimin",
  "adm1.settings_saved_live": "U ruajt! Ndryshimet janë menjëherë live.",
  "adm1.label_website_name": "Emri i faqes",
  "adm1.label_logo_url": "URL e logos",
  "adm1.label_favicon_url": "URL e favicon-it",
  "adm1.label_primary_color": "Ngjyra parësore",
  "adm1.label_accent_color": "Ngjyra e theksit",
  "adm1.label_secondary_color": "Ngjyra dytësore",
  "adm1.ph_new_password": "Fjalëkalim i ri...",
  "adm1.pw_too_short": "Fjalëkalimi duhet të ketë të paktën 6 karaktere.",
  "adm1.pw_changed": "Fjalëkalimi u ndryshua me sukses!",
  "adm1.footer_title": "Footer-i dhe Kontakti",
  "adm1.footer_subtitle": "Të dhënat e kontaktit dhe cilësimet e footer-it të faqes — pikërisht siç shfaqen në faqe.",
  "adm1.footer_contact_data": "Të dhënat e kontaktit",
  "adm1.footer_contact_data_desc": "Telefoni, email-i, adresa, orari i hapjes — si në footer dhe në faqen e kontaktit",
  "adm1.footer_social_desc": "Instagram dhe TikTok — pikërisht si janë lidhur në footer dhe në faqen e kontaktit",
  "adm1.footer_tiktok_note": "Aktualisht në faqe është lidhur vetëm një vendmbajtës (#).",
  "adm1.footer_whatsapp_floating": "WhatsApp (Buton pluskues)",
  "adm1.label_whatsapp_number": "Numri (pa +, p.sh. 41765593993)",
  "adm1.label_whatsapp_message": "Mesazh i paracaktuar",
  "adm1.footer_texts": "Tekstet e footer-it",
  "adm1.footer_texts_desc": "Slogani dhe të drejtat e autorit — si në footer-in e faqes",
  "adm1.label_tagline": "Slogani (nën logo)",
  "adm1.label_copyright": "Rreshti i të drejtave të autorit",
  "adm1.label_address": "Adresa",
  "adm1.label_city_zip": "Qyteti / Kodi postar",
  "adm1.label_country": "Shteti",
  "adm1.label_opening_hours": "Orari i hapjes",
  "adm1.login_title": "Hyrja e adminit",
  "adm1.login_subtitle": "Administrimi i Esteva Clinic",
  "adm1.login_failed": "Hyrja dështoi. Email-i ose fjalëkalimi është i pasaktë.",
  "adm1.label_password": "Fjalëkalimi",
  "adm1.ph_enter_password": "Vendos fjalëkalimin",
  "adm1.pw_hide": "Fshih fjalëkalimin",
  "adm1.pw_show": "Shfaq fjalëkalimin",
  "adm1.login_loading": "Po hyhet…",
  "adm1.login_submit": "Hyr",
  "adm2.saved": "U ruajt!",
  "adm2.save_error": "Gabim gjatë ruajtjes.",
  "adm2.save": "Ruaj",
  "adm2.cancel": "Anulo",
  "adm2.delete": "Fshi",
  "adm2.edit": "Redakto",
  "adm2.upload": "Ngarko",
  "adm2.reset": "Rivendos",
  "adm2.reset_all": "Rivendos të gjitha",
  "adm2.reset_lang": "Rivendos {{lang}}",
  "adm2.save_changes": "Ruaj ndryshimet",
  "adm2.saving": "Po ruhet...",
  "adm2.saved_short": "U ruajt",
  "adm2.saved_live": "U ruajt! Ndryshimet janë aktive.",
  "adm2.remove": "Hiq",
  "adm2.changed": "Ndryshuar",
  "adm2.optional": "opsionale",
  "adm2.preview": "Pamje paraprake",
  "adm2.uploaded": "U ngarkua",
  "adm2.uploading": "Po ngarkohet…",
  "adm2.uploading_progress": "Po ngarkohet...",
  "adm2.upload_failed": "Ngarkimi dështoi.",
  "adm2.upload_failed_retry": "Ngarkimi dështoi. Ju lutemi provoni përsëri.",
  "adm2.file_too_large": "Skedari shumë i madh (maks. 5 MB).",
  "adm2.file_too_large_compress": "Skedari shumë i madh (maks. 5 MB). Ju lutemi kompresojeni.",
  "adm2.file_too_large_max": "Skedari është shumë i madh. Madhësia maksimale: 5 MB.",
  "adm2.max_5mb_jpg_png": "Maks. 5 MB, JPG ose PNG",
  "adm2.only_jpg_png_webp": "Ju lutemi ngarkoni vetëm skedarë JPG, PNG ose WebP.",
  "adm2.only_image_files": "Ju lutemi zgjidhni vetëm skedarë imazhi (JPG, PNG, WebP).",
  "adm2.file_read_error": "Gabim gjatë leximit të skedarit. Ju lutemi provoni përsëri.",
  "adm2.file_read_error_smaller": "Gabim gjatë leximit të skedarit. Provoni një skedar më të vogël.",
  "adm2.no_image": "Pa imazh",
  "adm2.no_image_uploaded": "Ende nuk është ngarkuar asnjë imazh",
  "adm2.image_required": "Imazhi është i detyrueshëm",
  "adm2.edit_image": "Redakto imazhin",
  "adm2.upload_image": "Ngarko imazh",
  "adm2.remove_image": "Hiq imazhin",
  "adm2.image_url": "URL e imazhit",
  "adm2.image_url_optional": "URL e imazhit (opsionale)",
  "adm2.enter_image_url": "Ose shkruani drejtpërdrejt URL-në e imazhit...",
  "adm2.image_upload_hint": "Ngarkoni një imazh nga kompjuteri ose ngjisni një URL. Imazhet e ngarkuara ruhen lokalisht.",
  "adm2.or_url": "ose URL...",
  "adm2.enter_url": "ose shkruani URL...",
  "adm2.location": "Vendndodhja",
  "adm2.description": "Përshkrimi",
  "adm2.category": "Kategoria",
  "adm2.filter_all": "Të gjitha",
  "adm2.media_title": "Imazhe dhe media",
  "adm2.media_uploaded_count": "{{uploaded}} / {{total}} imazhe të ngarkuara",
  "adm2.manage_images": "Menaxho imazhet",
  "adm2.images": "Imazhet",
  "adm2.images_count": "{{uploaded}} / {{total}} imazhe",
  "adm2.customized": "I personalizuar",
  "adm2.no_images_category": "Asnjë imazh në këtë kategori.",
  "adm2.reset_all_images": "Rivendos të gjitha imazhet",
  "adm2.gallery_comparisons": "Krahasimet e galerisë",
  "adm2.gallery_before_after": "Galeria (Para/Pas)",
  "adm2.page_images": "Imazhet e faqeve",
  "adm2.to_website": "Te faqja e internetit",
  "adm2.gallery_intro": "Menaxho imazhet krahasuese para/pas për faqen e galerisë. Çdo hyrje përbëhet nga një imazh para dhe një imazh pas.",
  "adm2.new_comparison": "Krahasim i ri",
  "adm2.no_gallery_images_category": "Asnjë imazh galerie në këtë kategori.",
  "adm2.before": "Para",
  "adm2.after": "Pas",
  "adm2.before_image": "Imazhi para",
  "adm2.after_image": "Imazhi pas",
  "adm2.no_label": "Pa etiketë",
  "adm2.months_count": "{{count}} muaj",
  "adm2.new_before_after": "Krahasim i ri para/pas",
  "adm2.edit_comparison": "Redakto krahasimin",
  "adm2.add_comparison": "Shto krahasim",
  "adm2.patient_label": "Etiketa e pacientit",
  "adm2.patient_label_ph": "p.sh. Pacienti 29K",
  "adm2.treatment_label": "Etiketa e trajtimit",
  "adm2.treatment_label_ph": "p.sh. Estetikë dentare",
  "adm2.result_after_months": "Rezultati pas (muaj)",
  "adm2.result_desc_ph": "Përshkrim i shkurtër i rezultatit...",
  "adm2.cat_hero": "Hero dhe sfonde",
  "adm2.cat_services": "Shërbime",
  "adm2.cat_about": "Rreth nesh / Klinika",
  "adm2.cat_pricing": "Çmimet / Paketat",
  "adm2.cat_gallery": "Galeria (Para/Pas)",
  "adm2.cat_team": "Ekipi",
  "adm2.cat_instagram": "Instagram / Rrjetet sociale",
  "adm2.gcat_dental": "Estetikë dentare",
  "adm2.gcat_surgery": "Kirurgji",
  "adm2.gcat_hair": "Transplant flokësh",
  "adm2.gcat_aesthetic": "Estetikë",
  "adm2.img_home_hero_bg": "Faqja kryesore — Sfondi hero",
  "adm2.img_home_cta_bg": "Faqja kryesore — Sfondi CTA",
  "adm2.img_home_process": "Faqja kryesore — Sfondi i procesit",
  "adm2.img_home_trust": "Faqja kryesore — Sfondi i besimit",
  "adm2.img_about_hero": "Rreth nesh — Hero (Tirana)",
  "adm2.img_services_hero": "Shërbime — Hero",
  "adm2.img_pricing_hero": "Çmimet — Hero",
  "adm2.img_gallery_hero": "Galeria — Hero",
  "adm2.img_booking_hero": "Rezervimi — Hero",
  "adm2.img_hair": "Transplant flokësh — Imazh",
  "adm2.img_dental": "Estetikë dentare — Imazh",
  "adm2.img_botox": "Botoks dhe mbushës — Imazh",
  "adm2.confirm_delete": "Të fshihet vërtet?",
  "adm2.no_subscribers": "Nuk ka abonentë.",
  "adm2.csv_email": "Email",
  "adm2.csv_language": "Gjuha",
  "adm2.csv_status": "Statusi",
  "adm2.csv_date": "Data",
  "adm2.col_email": "Email",
  "adm2.col_language": "Gjuha",
  "adm2.col_status": "Statusi",
  "adm2.col_date": "Data",
  "adm2.col_actions": "Veprime",
  "adm2.pages_content_title": "Faqet dhe përmbajtja",
  "adm2.pages_content_subtitle": "Redaktoni përmbajtjen e çdo faqeje të faqes së internetit.",
  "adm2.language_label": "Gjuha:",
  "adm2.editable_fields_count": "{{count}} fusha të redaktueshme",
  "adm2.editable_fields_count2": "{{count}} fusha të redaktueshme",
  "adm2.no_fields_configured": "Asnjë fushë e konfiguruar për këtë faqe.",
  "adm2.pc_page_home": "Faqja kryesore",
  "adm2.pc_page_services": "Shërbime",
  "adm2.pc_page_about": "Rreth nesh",
  "adm2.pc_page_pricing": "Çmimet",
  "adm2.pc_page_gallery": "Galeria",
  "adm2.pc_page_team": "Ekipi",
  "adm2.pc_page_booking": "Rezervimi",
  "adm2.pc_page_contact": "Kontakti",
  "adm2.pc_hero_headline": "Titulli hero",
  "adm2.pc_hero_subline": "Nëntitulli hero",
  "adm2.pc_hero_button": "Butoni hero",
  "adm2.pc_about_heading": "Titulli Rreth nesh",
  "adm2.pc_about_text": "Teksti Rreth nesh",
  "adm2.pc_services_heading": "Titulli i shërbimeve",
  "adm2.pc_pricing_heading": "Titulli i çmimeve",
  "adm2.pc_testimonials_heading": "Titulli i vlerësimeve",
  "adm2.pc_hair_title": "Titulli Transplant flokësh",
  "adm2.pc_hair_desc": "Përshkrimi Transplant flokësh",
  "adm2.pc_hair_heading": "Titulli Transplant flokësh",
  "adm2.pc_dental_title": "Titulli Estetikë dentare",
  "adm2.pc_dental_desc": "Përshkrimi Estetikë dentare",
  "adm2.pc_dental_heading": "Titulli Estetikë dentare",
  "adm2.pc_botox_title": "Titulli Botoks dhe mbushës",
  "adm2.pc_botox_desc": "Përshkrimi Botoks dhe mbushës",
  "adm2.pc_botox_heading": "Titulli Botoks dhe mbushës",
  "adm2.pc_story_title": "Titulli Historia jonë",
  "adm2.pc_story_text": "Teksti Historia jonë",
  "adm2.pc_philosophy_title": "Titulli Filozofia",
  "adm2.pc_philosophy_text": "Teksti Filozofia",
  "adm2.pc_form_heading": "Titulli i formularit",
  "adm2.pc_ph_home_hero_title": "p.sh. Klinika juaj premium në Tiranë",
  "adm2.pc_ph_home_hero_sub": "p.sh. Trajtime cilësore me çmime të drejta...",
  "adm2.pc_ph_home_hero_cta": "p.sh. Rezervo një takim tani",
  "adm2.pc_ph_about_title": "p.sh. Rreth Esteva Clinic",
  "adm2.pc_ph_clinic_desc": "Përshkrimi i klinikës...",
  "adm2.pc_ph_our_services": "p.sh. Shërbimet tona",
  "adm2.pc_ph_pricing_packages": "p.sh. Paketat tona të çmimeve",
  "adm2.pc_ph_testimonials": "p.sh. Çfarë thonë klientët tanë",
  "adm2.pc_ph_services_sub": "p.sh. Zbuloni gamën tonë të plotë të trajtimeve...",
  "adm2.pc_ph_hair": "p.sh. Transplant flokësh",
  "adm2.pc_ph_dental": "p.sh. Estetikë dentare",
  "adm2.pc_ph_botox": "p.sh. Botoks dhe mbushës",
  "adm2.pc_ph_description": "Përshkrimi...",
  "adm2.pc_ph_about_sub": "p.sh. Klinika juaj premium në zemër të Tiranës...",
  "adm2.pc_ph_our_story": "p.sh. Historia jonë",
  "adm2.pc_ph_clinic_story": "Historia e klinikës...",
  "adm2.pc_ph_our_philosophy": "p.sh. Filozofia jonë",
  "adm2.pc_ph_our_prices": "p.sh. Çmimet tona",
  "adm2.pc_ph_pricing_sub": "p.sh. Çmime transparente — deri në 70% më lirë...",
  "adm2.pc_ph_gallery_title": "p.sh. Galeri para-pas",
  "adm2.pc_ph_gallery_sub": "p.sh. Rezultate reale të trajtimeve tona...",
  "adm2.pc_ph_our_team": "p.sh. Ekipi ynë",
  "adm2.pc_ph_team_sub": "p.sh. Njihuni me ekspertët tanë...",
  "adm2.pc_ph_book_appt": "p.sh. Rezervo një takim",
  "adm2.pc_ph_booking_sub": "p.sh. Caktoni tani takimin tuaj të konsultimit...",
  "adm2.pc_ph_your_data": "p.sh. Të dhënat tuaja",
  "adm2.pc_ph_contact": "p.sh. Kontakti",
  "adm2.pc_ph_contact_sub": "p.sh. Si të na kontaktoni...",
  "adm2.edit_page_title": "Redakto {{page}}",
  "adm2.manage_team_members": "Menaxho anëtarët e ekipit",
  "adm2.edit_pricing_treatments": "Redakto trajtimet e listës së çmimeve",
  "adm2.saved_de_synced": "U ruajt! (DE → u aplikua automatikisht në të gjitha gjuhët) Ndryshimet janë tani aktive.",
  "adm2.saved_lang_live": "U ruajt! ({{lang}}) Ndryshimet janë tani aktive.",
  "adm2.changes_reset_for": "Të gjitha ndryshimet për {{lang}} u rivendosën.",
  "adm2.lang_editor": "Redaktuesi i gjuhës ({{lang}})",
  "adm2.lang_editor_de_note": "Po redaktoni versionin DE. Ndryshimet aplikohen automatikisht në të gjitha gjuhët (EN, IT, ES, FR).",
  "adm2.lang_editor_other_note": "Po redaktoni versionin {{lang}}. Ndryshimet ruhen veçmas për këtë gjuhë.",
  "adm2.texts": "Tekstet",
  "adm2.key_label": "Çelësi:",
  "adm2.changed_original": "Ndryshuar — origjinali:",
  "adm2.no_editable_fields": "Asnjë fushë e redaktueshme",
  "adm2.no_configured_fields": "Kjo faqe nuk ka ende fusha të konfiguruara.",
  "adm2.read_only": "Vetëm për lexim",
  "adm2.translations_info": "Përkthimet mirëmbahen drejtpërdrejt në skedarët e gjuhëve. Kjo faqe tregon vlerat aktuale për shikim. Për ndryshime, kontaktoni zhvilluesin tuaj.",
  "adm2.pe_cat_dental": "Stomatologji",
  "adm2.pe_cat_surgery": "Kirurgji plastike",
  "adm2.pe_cat_hair": "Transplant flokësh",
  "adm2.pe_new_treatment": "Trajtim i ri",
  "adm2.pe_default_stay": "Spital ditor / 2 net hotel (3 ditë)",
  "adm2.pe_category_reset": "Të gjitha trajtimet {{category}} për {{lang}} u rivendosën.",
  "adm2.pe_confirm_reset_all": "Të rivendosen vërtet TË GJITHA listat e çmimeve në TË GJITHA gjuhët? Ky veprim nuk mund të zhbëhet.",
  "adm2.pe_all_reset": "Të gjitha listat e çmimeve u rivendosën plotësisht.",
  "adm2.pe_treatments_count": "{{count}} trajtim(e)",
  "adm2.pe_edit_hint": "Redaktoni emrin, çmimin dhe opsionalisht kohëzgjatjen e qëndrimit.",
  "adm2.pe_saved_lang": "U ruajt! ({{lang}})",
  "adm2.pe_treatment_name": "Emri i trajtimit",
  "adm2.pe_price_eur": "Çmimi (€)",
  "adm2.pe_price_ph": "p.sh. 350 – 400",
  "adm2.pe_stay": "Qëndrimi",
  "adm2.pe_stay_ph": "p.sh. Spital ditor / 2 net hotel",
  "adm2.pe_no_treatments_lang": "Asnjë trajtim në këtë gjuhë",
  "adm2.pe_no_treatments_hint": "Shtoni një trajtim të ri ose rivendosni të dhënat e parazgjedhura.",
  "adm2.pe_add_treatment": "Shto trajtim",
  "adm2.pe_total_treatments": "Gjithsej: {{count}} trajtime në {{lang}}",
  "adm2.pe_short_dental": "Dentare",
  "adm2.pe_short_surgery": "Kirurgji",
  "adm2.pe_short_hair": "Flokë",
  "adm2.tm_lang_de": "Gjermanisht",
  "adm2.tm_lang_it": "Italisht",
  "adm2.tm_lang_en": "Anglisht",
  "adm2.tm_lang_fr": "Frëngjisht",
  "adm2.tm_lang_es": "Spanjisht",
  "adm2.tm_lang_nl": "Holandisht",
  "adm2.tm_lang_pl": "Polonisht",
  "adm2.tm_lang_al": "Shqip",
  "adm2.tm_members_count": "Anëtarët e ekipit ({{count}})",
  "adm2.tm_add_member": "Shto anëtar",
  "adm2.tm_no_members": "Ende asnjë anëtar ekipi.",
  "adm2.tm_add_first_member": "Shto anëtarin e parë",
  "adm2.tm_new_member": "Anëtar i ri",
  "adm2.tm_edit_member": "Redakto anëtarin",
  "adm2.tm_profile_image": "Fotoja e profilit",
  "adm2.tm_upload_image_max": "Ngarko imazh (maks. 5 MB)",
  "adm2.tm_image_hint": "Rekomandohet imazh katror. Maks. 5 MB.",
  "adm2.tm_name": "Emri",
  "adm2.tm_name_ph": "p.sh. Nertila Basha",
  "adm2.tm_title_position": "Titulli / Pozicioni",
  "adm2.tm_title_ph": "p.sh. CEO, Dentiste",
  "adm2.tm_specialty": "Specialiteti",
  "adm2.tm_specialty_ph": "p.sh. Implante dentare dhe protetikë estetike",
  "adm2.tm_bio": "Biografia",
  "adm2.tm_bio_ph": "Biografi e shkurtër e anëtarit të ekipit...",
  "adm2.tm_languages": "Gjuhët",
  "adm2.tm_certifications": "Certifikata dhe kualifikime",
  "adm2.tm_cert_ph": "Certifikata {{num}}",
  "adm2.tm_add_cert": "Shto certifikatë",
  "shared.chat_title": "Asistenti Esteva",
  "shared.chat_online": "Online",
  "shared.chat_restart": "Rifillo",
  "shared.close": "Mbyll",
  "shared.book_appointment": "Rezervo takim",
  "shared.chat_input_placeholder": "Shkruani një mesazh...",
  "shared.send": "Dërgo",
  "shared.chat_close": "Mbyll bisedën",
  "shared.chat_open": "Hap bisedën",
  "shared.whatsapp_contact": "Kontakti WhatsApp",
  "shared.whatsapp_tooltip": "Na shkruani tani në WhatsApp",
  "shared.select_language": "Zgjidh gjuhën",
  "shared.image": "Imazh",
  "shared.image_too_large": "Skedari shumë i madh (maks. 10 MB).",
  "shared.image_upload_failed": "Ngarkimi dështoi. Ju lutemi provoni përsëri.",
  "shared.image_uploading": "Po ngarkohet…",
  "shared.image_select": "Zgjidh imazhin",
  "shared.image_url_placeholder": "ose ngjit një URL imazhi…",
  "shared.open_menu": "Hap menunë",
};

export default common;